import { inject, Injectable } from '@angular/core'
import { Router } from '@angular/router'

import { AuthService } from './auth.service'

@Injectable({
	providedIn: 'root',
})
export class SessionTimeoutService {
	private timeout: ReturnType<typeof setTimeout> | null = null

	private sessionTimeoutTime = 3600000

	private sessionKey = 'lastActivityTime'

	router = inject(Router)

	authService = inject(AuthService)

	setupSessionTimeout() {
		this.restoreSession()
		this.resetTimeout()
		this.addActivityListeners()
		this.handleTabEvents()
	}

	private addActivityListeners(): void {
		;['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach((event) => {
			window.addEventListener(event, () => this.resetTimeout())
		})
	}

	private saveSessionActivity(): void {
		if (this.sessionTimeoutTime > 0 && this.authService.getAccessToken()) {
			const currentTime = Date.now()
			sessionStorage.setItem(this.sessionKey, currentTime.toString())
		}
	}

	private resetTimeout(): void {
		if (this.timeout) {
			clearTimeout(this.timeout)
		}
		this.saveSessionActivity()
		if (this.sessionTimeoutTime > 0 && this.authService.getAccessToken()) {
			this.timeout = setTimeout(() => {
				this.logout()
			}, this.sessionTimeoutTime)
		}
	}

	private restoreSession(): void {
		const lastActivity = sessionStorage.getItem(this.sessionKey)
		if (lastActivity) {
			const elapsedTime = Date.now() - parseInt(lastActivity, 10)
			if (elapsedTime > this.sessionTimeoutTime) {
				this.logout()
			}
		}
	}

	private handleTabEvents(): void {
		document.addEventListener('visibilitychange', () => {
			if (document.visibilityState === 'visible') {
				this.restoreSession()
				this.resetTimeout()
			}
		})
		window.addEventListener('beforeunload', () => {
			this.saveSessionActivity()
		})
	}

	private logout() {
		this.authService.logOut()
	}
}
